export const docs = {
  // /v2/api/aawz-contracts
  /**
   * @method GET Listar os signatarios cadastrados
   *
   * @method POST Salvar um novo signatario. Salvar com id repetido vai sobrescrever o antigo.
   * @param {Object} data
   *    @param {String} email Nao pode ser o email da empresa. Precisa ser o email pessoal.
   *    @param {Number} id_profissional Identificacao do profissional
   */
  signer: '/v2/api/aawz-contracts/signer',
  /**
   *
   * @method POST Salvar um grupo de signatarios.
   * @param {Array} data
   *    @param {Object}
   *      @param {String} email Nao pode ser o email da empresa. Precisa ser o email pessoal.
   *      @param {String} cpf Nao pode ser o cpf do profissional/agente.
   *      @param {String} sign_as Nao pode ser nulo.
   *      @param {Number} id_profissional Identificação do profissional
   *      @param {Number} id_agente_externo Identificação do agente externo
   */
  signerBulk: (id) => `/v2/api/aawz-contracts/documents/${id}/attach-signers`,
  /**
   * @method GET Listar os templates para documentos
   * @param {Boolean} model Verdadeiro para baixar o modelo (estrutura base64)
   * @param {String} /:id Filtrar os dados por um template especifico
   *
   * @method POST Salvar um documento como template
   * @param {FileStorage} file Arquivo.docx
   * @param {Object} data
   *    @param {String} nome_template Esse nome nao pode ser repetido.
   */
  templates: '/v2/api/aawz-contracts/templates',
  /**
   * @param id Identificacao do template
   * @returns {String} url formatada com o id do template
   *
   * @method GET Listar variaveis de um template
   * @param {String} /:id Buscar por um id especifico de variavel
   *
   * @method POST Salvar o DE-PARA de uma variavel do template
   * @param {Object} data
   *    @param {String} nome_variavel
   *    @param {String} tipo_dado
   *    @param {String} nome_variavel_sistema
   */
  variables: (id) => `/v2/api/aawz-contracts/templates/${id}/variables`,
  /**
   * @method GET Listar documentos criados
   * @param {String} /:id Para procurar por um documento especifico
   *
   * @method POST Criar um novo documento
   * @param {Object} data
   *    @param {String} id_template
   *    @param {String} nome_documento Com extensao (ex: teste.docx)
   * @param {Object} config Opcional - configuracoes do documento
   *    @param {Number} remind_interval [1,2,3,7,14]
   *    @param {Boolean} block_after_refusal
   *    @param {Date} deadline_at YYYY-MM-DD
   *
   * @param PUT Editar as configurações de um documento
   * @param {Object} config Configuracoes do documento
   *    @param {Number} remind_interval [1,2,3,7,14]
   *    @param {Boolean} block_after_refusal
   *    @param {Date} deadline_at YYYY-MM-DD
   */
  documents: '/v2/api/aawz-contracts/documents',
  /**
   * @param id Identificacao do documento
   * @returns {String} url formatada para os signatarios de um documento
   *
   * @method GET Lista de signatarios do documento
   *
   * @method POST Adicionar signatarios ao documento
   * @param {Object} data
   *    @param {String} id_signatario
   *    @param {String} sign_as Role/papel do signatario no documento
   *    @param {String} message Mensagem enviada ao signatario
   *
   * @method DELETE Remover o signatario do documento
   * @param {String} /:id Identificacao da assinatura
   */
  documentSigners: (id) => `/v2/api/aawz-contracts/documents/${id}/signers`,
  /**
   * @param id Identificacao do documento
   * @returns {String} url formatada para os signatarios de um documento
   *
   * @method PUT Enviar uma notificacao para TODOS os signatarios do documento
   * @param {Object} data
   *    @param {String} message Mensagem a ser enviada
   */
  documentSignersNotify: (id) =>
    `/v2/api/aawz-contracts/documents/${id}/signers/notify`,
  /**
   * @method POST Salvar um documento em formato PDF
   * @param {Object} data
   *    @param {String} nome_documento
   * @param {Object} config
   *    @param {Integer} remind_interval
   *    @param {Boolean} block_after_refusal
   *    @param {Date} deadline_at YYYY-MM-DD
   * @param {FileStorage} file
   */
  pdf: '/v2/api/aawz-contracts/documents-from-pdf',
  /**
   * @method PUT
   * @param {Array} recipients array of recipient with data ex.: {id_profissional: 1, email:'test@test.com'}
   * @param {String} subject subject of the documents
   */
  notify: '/v2/api/aawz-contracts/documents/notify',

  /**
   * @method GET
   * @param id id do modelo
   */
  downloadModel: (id) => `/v2/api/aawz-contracts/templates/${id}/download`,
}

export const external = {
  /**
   * @method POST Importar um contrato externo
   * @poram {FileStorage} file
   * @param {Object} data {nome_documento}
   */
  import: '/v2/api/aawz-contracts/documents-signed/import',
}

export const variables = {
  /**
   * @method GET Listar as variaveis disponiveis no sistema.
   */
  system: '/v2/api/aawz-contracts/system-variables',
  /**
   * @method GET Listar dados disponíveis no escritorio.
   */
  options: '/v2/api/aawz-contracts/system-variables/options',
}

export const envelope = {
  /**
   * @method GET Listar os documentos pendentes de envio para assinatura,
   * agrupados por lote (envelope) aberto na Clicksign — um lote por
   * signatário (`email_signatario`).
   * @returns {Object} value
   *    @param {Number} total_documentos
   *    @param {Array} lotes
   *      @param {String} email_signatario
   *      @param {String} provider_envelope_id
   *      @param {String} status status do envelope na Clicksign (ex: 'draft')
   *      @param {Number} qtd_documentos
   *      @param {String} aberto_desde 'DD/MM/YYYY HH:mm' (America/Sao_Paulo,
   *        formatado por JSONEncoderExtendedDataFrames — não é ISO)
   *      @param {Array} documentos lista de {nome}
   *      @param {Boolean} documentos_indisponiveis true quando a lista de
   *        nomes não pôde ser resolvida — NÃO é erro, apenas indisponível
   *        no momento; a quantidade em `qtd_documentos` continua válida.
   *
   * Sem lote pendente, a resposta é 200 com `{ total_documentos: 0, lotes: [] }`
   * (nunca 404).
   */
  pendentes: '/v3/api/aawz-compliance/documents/envelope/pendentes',
  /**
   * @method POST Notificar (enviar) o lote pendente de N signatários numa
   * única chamada (1 request com a lista, em vez de N requests client-side —
   * ver `notificarLotes` em `apiDocumentsEnvelope.js` para o porquê).
   * @param {Object} data
   *    @param {Array<String>} emails_signatarios
   *
   * ⚠️ O `status` de topo da resposta é sempre 200, mesmo quando todos os
   * lotes falham — quem classifica sucesso/parcial/falha é o consumidor,
   * lendo `value.resultados` (1 item por `email_signatario`, com `status`/
   * `message` próprios). Rate limit da Clicksign (1 notificação/minuto)
   * aparece como um item com status 429, esperado em lista com mais de 1
   * signatário.
   * @returns {Object} value
   *    @param {Array} resultados
   *      @param {String} email_signatario
   *      @param {Number} status
   *      @param {String} message
   *      @param {Array} notificacoes
   */
  notify: '/v3/api/aawz-compliance/documents/envelope/notify',
}

export const pjsEdit = {
  /**
   * @method POST Importar um contrato externo
   *
   * @param {Object} data {"id_pj": 56, "id_documento": "848a0924-b09f-4140-8a9e-63961b0757c0"}
   */
  addDelete: (id) =>
    id
      ? `/v3/api/aawz-conjunto-documentos/partners-contratos-documentos-pj/${id}`
      : '/v3/api/aawz-conjunto-documentos/partners-contratos-documentos-pj',
}
